export default {
  title: 'Palkinnot',
  guest: {
    eyebrow: 'Palkinnot',
    headline: 'Jokainen tilaus tuo sinulle <highlight>palkintoja</highlight>',
    subheading_one: 'Ansaitse {{count}} piste per {{amount}} käytetty.',
    subheading_other: 'Ansaitse {{count}} pistettä per {{amount}} käytetty.',
    cta: 'Rekisteröidy ja ala ansaita',
    already_member: 'Oletko jo jäsen?',
    sign_in: 'Kirjaudu sisään',
    redeemable_heading: 'Pisteesi = ilmaista ruokaa',
    redeemable_eyebrow: '🎁 Palkinnot, jotka avaat',
  },
  member: {
    balance_label: 'Saldosi',
    balance_suffix: 'pistettä · arvo <highlight>{{amount}}</highlight>',
    next_reward: 'Seuraava palkinto <highlight>{{points}} pisteellä</highlight>',
    redeem_hint: '✓ Voit lunastaa jopa {{points}} pistettä ({{amount}}) seuraavassa tilauksessasi',
    expiration_zero: '⏳ {{points}} pistettä vanhenee tänään',
    expiration_one: '⏳ {{points}} pistettä vanhenee 1 päivässä',
    expiration_other: '⏳ {{points}} pistettä vanhenee {{count}} päivässä',
    pts_lifetime: 'Pisteitä yhteensä',
    saved_lifetime: 'Säästetty yhteensä',
    cta: 'Tilaa nyt',
    redeemable_heading: 'Mitä voit lunastaa',
    redeemable_eyebrow: 'Sinulla on {{points}} pistettä ({{amount}})',
    redeemable_description:
      'Jopa {{maxPoints}} pistettä ({{maxAmount}}) per tilaus. Alle {{maxAmount}} maksavat tuotteet ovat täysin ilmaisia.',
  },
  items: {
    free: 'ILMAINEN',
    save: 'Säästä {{amount}}',
  },
  history: {
    eyebrow: 'Historia',
    title: 'Viimeaikainen toiminta',
    load_more: 'Lataa lisää',
    sources: {
      welcome_bonus: 'Tervetuliaisbonus',
      google_review_reward: 'Google-arvostelupalkinto',
      reward_loyalty_program_conversion: 'Kanta-asiakasohjelman muunnos',
      cashback: 'Ansaittu käteispalautus',
      refund: 'Tilaus hyvitetty',
      cashback_usage: 'Pisteet lunastettu',
      cashback_usage_refund: 'Lunastus hyvitetty',
      expired_points_void: 'Pisteet vanhentuneet',
      mobile_app_signup_bonus: 'Mobiilisovelluksen rekisteröitymisbonus',
    },
    detail_with_order: 'Tilaus #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Yksinkertaista & automaattista',
    eyebrow_member: 'Nopea muistutus',
    title: 'Näin se toimii',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Rekisteröidy ilmaiseksi',
        desc: 'Luo tili 30 sekunnissa.',
      },
      order: {
        emoji: '🍔',
        title: 'Tilaa ja ansaitse',
        desc_one: '1 pist. / {{amount}} — automaattinen seuranta.',
        desc_other: '{{count}} pist. / {{amount}} — automaattinen seuranta.',
      },
      build: {
        emoji: '⭐',
        title: 'Kerää pisteitä',
        desc: 'Lunasta alkaen {{minPoints}} pist. Voimassa {{lifetime}} päivää.',
      },
      save: {
        emoji: '🎁',
        title: 'Säästä kassalla',
        desc: 'Jopa {{maxAmount}} alennusta — käytössä heti.',
      },
      repeat: {
        emoji: '🔄',
        title: 'Tilaa uudelleen ja säästä',
        desc: 'Jokainen tilaus kasvattaa saldoasi.',
      },
    },
  },
  faq: {
    eyebrow: 'Kysyttävää?',
    title: 'Usein kysytyt kysymykset',
    items: {
      earn: {
        q: 'Miten ansaitsen pisteitä?',
        a_one:
          'Ansaitset 1 pisteen jokaista {{amount}} kohden, jonka käytät. Pisteet lisätään tilillesi automaattisesti jokaisen tilauksen jälkeen — ei skannausta tai koodeja tarvita.',
        a_other:
          'Ansaitset {{count}} pistettä jokaista {{amount}} kohden, jonka käytät. Pisteet lisätään tilillesi automaattisesti jokaisen tilauksen jälkeen — ei skannausta tai koodeja tarvita.',
      },
      redeem: {
        q: 'Milloin voin alkaa lunastaa pisteitä?',
        a: 'Voit alkaa lunastaa pisteitä, kun saavutat {{minPoints}} pistettä. Käytä niitä kassalla pienentääksesi tilauksesi loppusummaa.',
      },
      max: {
        q: 'Kuinka paljon voin säästää tilausta kohden?',
        a: 'Voit lunastaa enintään {{maxPoints}} pistettä ({{maxAmount}}) tilausta kohden. Tämä on suurin alennus, jonka voit käyttää yhdessä tilauksessa.',
      },
      validity: {
        q: 'Kuinka kauan pisteet ovat voimassa?',
        a: 'Pisteet ovat voimassa {{lifetime}} päivää ansaintapäivästä. Käytä ne ennen kuin ne vanhenevat!',
      },
    },
  },
};
